// extracted by mini-css-extract-plugin
export var label = "_f9-2";
export var slideContainer = "_f9-0";
export var slider = "_f9-1";